module.exports = __webpack_public_path__ + "static/users-407ec61ebcbc561cb1f2924206051526.png";